import { FC } from 'react';
import styles from './FloatingButton.module.scss';
import Stars from '../../Modals/AiChatModal/AiButton/Stars';
import { Tooltip } from 'antd';

interface FloatingButtonProps {
  onClick: () => void;
}

const TooltipContent: FC = () => (
  <div className={styles.tooltipContent}>
    Abrir Coordia
    <span className={styles.key}>Alt</span>
    <span className={styles.key}>K</span>
  </div>
);

const FloatingButton: FC<FloatingButtonProps> = ({ onClick }) => {
  return (
    <Tooltip
      title={<TooltipContent />}
      placement="left"
      mouseEnterDelay={0}  
      mouseLeaveDelay={0}  
    >
      <button className={styles.fab} onClick={onClick}>
        <Stars hover={false} />
      </button>
    </Tooltip>
  );
};

export default FloatingButton;
